import {Injectable} from '@angular/core';
import {UserContextService} from '../../../core/services/user-context.service';
import {UserDetailsModel} from '../../auth/models/user-details-model';
import {IDataProcessingAgreementHttpService} from './data-processing-agreement.http.service.interface';
import {ModalDynamicV3Service} from '../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {
    ModalDataProcessingAgreementNotConfirmedInfoComponent
} from '../components/modal-data-procesing-agreement-not-confirmed-info/modal-data-procesing-agreement-not-confirmed-info.component';
import {AppEventsService} from '../../../core/services/app-events.service';
import {
    ModalDataProcessingAgreementNewComponent
} from '../components/modal-services-data-processing-agreement-new/modal-data-processing-agreement-new.component';

@Injectable()
export class DataProcessingAgreementService {
    private agreement: any;
    private isAgreementApproved: boolean = false;

    constructor(
        private userContextService: UserContextService,
        private dataProcessingAgreementService: IDataProcessingAgreementHttpService,
        private modalDynamicV3Service: ModalDynamicV3Service,
        private appEventsService: AppEventsService,
    ) {
    }

    public isRepresentativeOrPrimaryUser() {
        const userDetails = this.userContextService.getUserDetails();
        console.error('userDetails', userDetails, userDetails.isRepresentative, userDetails.primaryUser);
        return userDetails.isRepresentative || userDetails.primaryUser;
    }

    async areThereDocumentsForApproval(): Promise<boolean> {
        const userDetails = this.userContextService.getUserDetails() || {} as UserDetailsModel;
        try {
            this.agreement = await this.dataProcessingAgreementService.getLatestDataProcessingAgreement();
        } catch (e) {
            this.agreement = null;
        }

        return !!this.agreement;
    }

    async processDataProcessingAgreement() {
        console.log('processDataProcessingAgreement');

        if (await this.areThereDocumentsForApproval()) {
            if (this.isRepresentativeOrPrimaryUser()) {
                const dialogRef = this.modalDynamicV3Service.open(ModalDataProcessingAgreementNewComponent, {model: {agreement: this.agreement}});
                dialogRef.subscribe(async (result: any) => {
                    if (result.dialogConfirmed) {
                        try {
                            await this.dataProcessingAgreementService.acceptDataProcessingAgreement(this.agreement.id);
                            this.isAgreementApproved = true;
                        } catch (e) {
                            this.isAgreementApproved = true;
                        }
                    } else {
                        this.appEventsService.announceAppEvent(this.appEventsService.APP_EVENT_ENUM.LOGOUT);
                        await this.modalDynamicV3Service.openAsPromise(ModalDataProcessingAgreementNotConfirmedInfoComponent);
                    }
                });
            }
        } else {
            this.isAgreementApproved = true;
        }
    }


}
